/* eslint-disable react/no-danger */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import BaseBlocks from './BaseBlocks';
import * as BlockComponents from './index-stack';

import styles from '../../../styles/blocks/stack.module.scss';

const propTypes = {
    blocks: AppPropTypes.blocks,
    direction: PropTypes.oneOf(['horizontal', 'vertical']),
    className: PropTypes.string,
    isContainer: PropTypes.bool,
    containerClassName: PropTypes.string,
};

const defaultProps = {
    blocks: [],
    direction: 'horizontal',
    className: null,
    isContainer: false,
    containerClassName: null,
};

const StackBlock = ({ blocks, direction, className, isContainer, containerClassName }) => (
    <div
        className={classNames([
            styles.container,
            {
                [className]: className !== null,
            },
        ])}
    >
        <div
            className={classNames([
                'blockStack',
                styles.inner,
                {
                    [styles.isContainer]: isContainer,
                    [containerClassName]: isContainer && containerClassName !== null,
                },
            ])}
        >
            <BaseBlocks
                blocks={blocks}
                components={{
                    ...BlockComponents,
                    Stack: StackBlock,
                }}
                className={classNames([styles.stack, styles[direction]])}
                blockClassName={styles.item}
                isHorizontalStack={direction === 'horizontal'}
            />
        </div>
    </div>
);

StackBlock.propTypes = propTypes;
StackBlock.defaultProps = defaultProps;

export default StackBlock;
